import React from 'react';
import UserAvatar from '../Users/UserAvatar';
import CardRow from '../Kanban/CardRow';
import FlagIcon from '@mui/icons-material/Flag'
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined'
import PlayIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import IconButton from '@mui/material/IconButton';
import mainStore from '../../../MainStore'
import AuthStore from '../../Auth/AuthStore'
import WorkStore from '../Kanban/WorkStore'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import SchedulleStore from '../Scheduller/SchedulleStore';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

export default class KanbanCard extends React.PureComponent {
    constructor(props) {
        super(props);

        var timer = localStorage.getItem("timer" + props.work.id);

        if (timer) {
            timer = JSON.parse(timer);
            this.continueTime();
        }

        this.state = {
            isTimeDialogOpen: false,
            isFlagTooltipOpen: false,
            time: '',
            comment: '',
            needLogin: false,
            newNotify: '',
            isCommentDialogOpen: false,
            flagDialogTitle: '',
            flagComment: '',
            flagUser: '',
            flagDate: '',
            currentTime: timer && timer.startTime ? ((new Date() - new Date(timer.startTime)) / 1000).toFixed(0) : 0,
            isTimerStarted: timer ? timer.isTimerStarted : false,
            timerId: timer ? timer.timerId : '',
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleCardClick = this.handleCardClick.bind(this);
        this.flag = this.flag.bind(this);
        this.unFlag = this.unFlag.bind(this);
        this.startTime = this.startTime.bind(this);
        this.continueTime = this.continueTime.bind(this);
        this.stopTime = this.stopTime.bind(this);
        this.onWatchClick = this.onWatchClick.bind(this);
        this.onCardClick = this.onCardClick.bind(this);
        this.handleFlagTooltipOpen = this.handleFlagTooltipOpen.bind(this);
        this.handleFlagTooltipClose = this.handleFlagTooltipClose.bind(this);
    }

    /*shouldComponentUpdate(nextProps, nextState) {
        //console.log(this.props.work !== nextProps.work);
        //console.log(this.state.isOver + ' ' + nextState.isOver);
        //console.log(this.props);
        /*if (this.props.isDragging) {
            console.log(nextState);
            console.log(this.state);
        }*/
    /*return this.props.isDragging || this.props.isDragging !== nextProps.isDragging || this.props.snapshot !== nextProps.snapshot || this.props.work !== nextProps.work;
}*/

    handleFlagTooltipOpen() {
        var scope = this;
        fetchWithAuth(
            'api/Work/GetFlagInfo',
            JSON.stringify(
                this.props.work.id
            ),
            'application/json',
            (result) => {
                scope.setState({ isFlagTooltipOpen: true, flagDate: result.date, flagComment: result.commentText, flagUser: result.user });
            }
        );
    }

    handleFlagTooltipClose() {
        this.setState({ isFlagTooltipOpen: false });
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleCardClick(e) {
        if (e.ctrlKey && this.props.onCtrlCardClick) {
            this.props.onCtrlCardClick(this.props.work.id);
        }
    }

    formatTime(time, useSecond = true) {
        var str = "";
        var hours = Math.floor(time / 3600);
        if (hours > 0 && hours < 10) {
            str += '0' + hours + "ч ";
        }
        else if (hours >= 10) {
            str += hours + "ч ";
        }

        var minutes = Math.floor((time / 60) % 60);

        if (minutes >= 10) {
            str += minutes + "м ";
        }
        else {
            str += '0' + minutes + "м ";
        }

        if (useSecond) {
            var seconds = time % 60;

            if (seconds >= 10) {
                str += seconds + "с";
            }
            else {
                str += '0' + seconds + "с";
            }
        }

        return str;
    }

    continueTime() {
        var scope = this;
        var timer = JSON.parse(localStorage.getItem("timer" + this.props.work.id));
        var timerId = window.setInterval(() => {
            scope.setState({ currentTime: ((new Date() - new Date(timer.startTime)) / 1000).toFixed(0) });
        }, 1000);
        timer.timerId = timerId;
        localStorage.setItem("timer" + this.props.work.id, JSON.stringify(timer));
    }

    startTime() {
        var scope = this;
        var timerId = window.setInterval(() => {
            scope.setState({ currentTime: scope.state.currentTime + 1 });
        }, 1000);
        localStorage.setItem("timer" + this.props.work.id, JSON.stringify({ isTimerStarted: true, timerId: timerId, currentTime: 0, startTime: new Date() }));
        this.setState({ isTimerStarted: true, timerId: timerId, currentTime: 0 });
    }

    stopTime() {
        //localStorage.setItem("timer" + this.props.work.id, JSON.stringify({ isTimerStarted: true, timerId: timerId, workId: this.props.work.id, currentTime: 0 }));
        //this.setState({ isTimerStarted: true, timerId: timerId, currentTime: 0 });
        var timer = JSON.parse(localStorage.getItem("timer" + this.props.work.id));
        localStorage.setItem("timer" + this.props.work.id, '');
        this.setState({ isTimerStarted: false });
        if (timer && timer.timerId) window.clearInterval(timer.timerId);

        var currentMinutes = this.formatTime(((new Date() - new Date(timer.startTime)) / 1000).toFixed(0), false);
        SchedulleStore.openSchedulleEditDialog({ workId: this.props.work.id, date: new Date(), workNumber: this.props.work.number, workCaption: this.props.work.caption }, currentMinutes);
        //var scope = this;
        //mainStore.setMaskVisible();
        //var token = localStorage.getItem("token");
        //fetch('api/Schedulle/EditTime', {
        //    method: 'POST',
        //    body: JSON.stringify({ id: null, minutes: currentMinutes, date: new Date(), workId: this.props.work.id, comment: '' }),
        //    headers: {
        //        'Content-Type': 'application/json',
        //        'Authorization': 'Bearer ' + token
        //    }
        //}).then(function (res) {
        //    if (res.status === 401) {
        //        AuthStore.openLogin();
        //        mainStore.setMaskUnvisible();
        //        //scope.startSearch(); Перезагрузить доску?
        //    }
        //    else {
        //        res.json().then((result) => {
        //            mainStore.setMaskUnvisible();
        //        }).catch((err) => console.log(err));
        //    }
        //});
    }

    flag() {
        WorkStore.openCommenDialog('Почему ты флажишь?', this.props.work.id, true);
        //this.setState({ isCommentDialogOpen: true, newFlag: true, flagDialogTitle: , flagComment: '' });
    }

    unFlag() {
        WorkStore.openCommenDialog('Почему ты убираешь флаг?', this.props.work.id, false);
        //this.setState({ isCommentDialogOpen: true, newFlag: false, flagDialogTitle: 'Почему ты убираешь флаг?', flagComment: '' });
    }

    onWatchClick() {
        SchedulleStore.openSchedulleEditDialog({ workId: this.props.work.id, date: new Date(), workNumber: this.props.work.number, workCaption: this.props.work.caption });
    }

    onCardClick(e) {
        !e.ctrlKey && this.props.onCardOpen(this.props.work);
    }

    onCopy() {
        mainStore.openSnackbar('Скопировано в буфер обмена');
    }

    getStyle(provided, style) {
        if (!style) {
            return provided.draggableProps.style;
        }

        return {
            ...provided.draggableProps.style,
            ...style,
        };
    }

    render() {
        //console.log("render " + this.props.work.id);
        const { provided, innerRef, style } = this.props;
        return (
            <div className="card-draggable-wrapper"
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                ref={innerRef}
                style={this.getStyle(provided, style)}>
                <div onClick={this.handleCardClick}
                    className={"clearfix card-wrapper priority-shadow-" + this.props.work.priorityId + (this.props.work.isSelected ? ' selected' : '') + (!this.props.work.isFlagged ? '' : ' flagged') + (!this.props.work.isPortal ? '' : ' portal-card')}
                >
                    <div className="not-pointers">
                        <div className={"card-row clearfix priority-gradient-" + this.props.work.priorityId}>
                            <div className="small-card-number"><CopyToClipboard onCopy={this.onCopy} text={document.location.origin + '/board?work=' + encodeURIComponent(this.props.work.number)}><span>{this.props.work.number}</span></CopyToClipboard></div>
                            <div className="watch"
                                onClick={this.onWatchClick}
                            ></div>
                            {this.props.work.isFlagged &&
                                <HtmlTooltip open={this.state.isFlagTooltipOpen} onOpen={this.handleFlagTooltipOpen} onClose={this.handleFlagTooltipClose} title={
                                    <React.Fragment>
                                        <div>Flagged by: {this.state.flagUser} в {this.state.flagDate}</div>
                                        <div>{this.state.flagComment}</div>
                                    </React.Fragment>
                                    }>
                                <IconButton
                                    key="flag"
                                    aria-label="флаг"
                                    color="inherit"
                                    className="flag-button"
                                    onClick={this.unFlag}
                                    size="large">
                                    <FlagIcon style={{ fill: 'red' }} />
                                    </IconButton>
                                </HtmlTooltip>}
                            {!this.props.work.isFlagged &&
                                <IconButton
                                    key="flag"
                                    aria-label="флаг"
                                    color="inherit"
                                    className="flag-button flag-grey"
                                    onClick={this.flag}
                                    size="large">
                                    <FlagOutlinedIcon />
                                </IconButton>}
                            <div className="kanban-card-loyalty-level" style={{ "color": this.props.work.loyaltyLevelColor }}>{this.props.work.loyaltyLevelName}</div>
                            {!this.state.isTimerStarted && <IconButton
                                key="play"
                                aria-label="начать отсчет"
                                color="inherit"
                                className="play-button"
                                onClick={this.startTime}
                                size="large">
                                <PlayIcon />
                            </IconButton>}
                            {this.state.isTimerStarted && <IconButton
                                key="stop"
                                aria-label="начать отсчет"
                                color="inherit"
                                className="play-button"
                                onClick={this.stopTime}
                                size="large">
                                <StopIcon />
                            </IconButton>}
                            {this.state.isTimerStarted && <div className="timer-value">{this.formatTime(this.state.currentTime)}</div>}
                        </div>
                        <div onClick={this.onCardClick} className="card-inner-info">
                            <div className="card-row clearfix">
                                <div className="small-card-caption">{this.props.work.caption}</div>
                                {this.props.work.assigneeRoleId !== 'ebab48fb-df8d-4a1f-818e-8cf7572a2e79' && <div className={"sp-block " + (((this.props.work.approvedHour > 0 && this.props.work.factTotal > this.props.work.approvedHour) || (this.props.work.planHour > 0 && this.props.work.factTotal > this.props.work.planHour)) ? "red" : "")}>{!mainStore.getIsFilterByProduct ? this.props.work.factTotal.toFixed(0) : this.props.work.estimated}</div>}
                            </div>
                            <div className="card-row clearfix">
                                {this.props.work.projectName && <div className="project-block" style={{ background: this.props.work.projectColor }}>{this.props.work.projectName}</div>}
                                {!this.props.work.projectName && this.props.work.account && <div className="project-block" style={{ background: this.props.work.accountColor }}>{this.props.work.account}</div>}
                                <div className="work-card-avatar-block">{this.props.work.assigneeId && <UserAvatar userId={this.props.work.assigneeId} />}</div>
                            </div>
                            {this.props.work.tester && <div className="card-row clearfix">
                                Тестирует <div className="work-card-avatar-block">{this.props.work.tester}</div>
                            </div>}
                            <div className="card-row clearfix card-bottom-panel">
                                <div className="time-block">Согл, ч: {this.props.work.approvedHour} План, ч: {this.props.work.planHour} Факт, ч: {this.props.work.factTotal.toFixed(2)}</div>
                            </div>
                        </div>
                    </div>
                    {this.props.work.daysWithoutStageChange >= 5 && <div className="card-sleep-block" ><HourglassTopIcon></HourglassTopIcon> {this.props.work.daysWithoutStageChange}</div>}
                </div>
            </div>
        );
    }
}
